import { Upload, Spin, Typography, Button, Tooltip, notification, Card, Popconfirm, Result } from 'antd';
import React, { useState, useEffect } from 'react';
import { InboxOutlined, DeleteOutlined, UploadOutlined } from '@ant-design/icons';

import { anonymize_chatgpt_data } from '../../platforms/chatgpt/anonymizer';
import { anonymize_gemini_data } from '../../platforms/gemini/anonymizer';
import { anonymize_claude_data } from '../../platforms/claude/anonymizer';
import { anonymize_deepseek_data } from '../../platforms/deepseek/anonymizer';
import { anonymize_mistral_data } from '../../platforms/mistral/anonymizer';
import { anonymize_grok_data } from '../../platforms/grok/anonymizer';

import '../../styles/Stepper.css';
import { SendToBackend, FetchFromBackend, ErrorConnectionFailed,UploadFiles } from '../../shared/HelperContactBackend';
import { Link } from 'react-router-dom';

import { calculate_payment_amount_chatgpt, calculate_payment_amount_gemini, calculate_payment_amount_claude, calculate_payment_amount_deepseek, calculate_payment_amount_mistral, calculate_payment_amount_grok} from '../../shared/utils/payment';
import { validateConversationSignature } from '../../shared/utils/user_data_personaliser'

// filtering donation options 
import { filterDonationOptionsForPlatform } from '../../shared/utils/filterDonationOptions';

import {PageDone} from './StepDone';


import JSZip from 'jszip';

const endPoint = "https://social-media-data-donator.mpi-sws.org/api";


var md5 = require('md5');

const { Dragger } = Upload;
const { Text, Title } = Typography;


function validateDepData(depData, platform) {
    switch (platform) {
    case "chatgpt":
            return depData?.conversations && Array.isArray(depData.conversations);
        case "gemini":
            return depData?.conversations && Array.isArray(depData.conversations);

        case "claude":
            return depData?.conversations && Array.isArray(depData.conversations);

        case "mistral":
            return depData?.conversations && Array.isArray(depData.conversations);
        case 'deepseek': 
            return depData?.conversations && Array.isArray(depData.conversations);
        case 'grok':
            // grok has nested conversations object 
            return depData?.conversations && Array.isArray(depData.conversations);
        default:
            return false; 
    }
}


async function verify90DaysofActivity(verificationData) {
    const resp = await fetch(`${endPoint}/verify_activity/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(verificationData),
    });

    if (!resp.ok) {
        throw new Error(`verify_activity failed: ${resp.status}`);
    }

    const data = await resp.json();
    return !!data?.active_for_90_days;
}


function extractTimestamps(conversations, platform) {
    const timestamps = [];
    
    if (platform === 'gemini') {
        for (const message of conversations) {
            if (message.time) timestamps.push(message.time);
        }
    } else if (platform === 'claude') {
        for (const convo of conversations) {
            for (const message of convo.chat_messages || []) {
                for (const content of message.content || []) {
                    if (content.start_timestamp) timestamps.push(content.start_timestamp);
                }
            }
        }
    } else if (platform === 'deepseek') {
        for (const convo of conversations) {
            for (const [key, value] of Object.entries(convo.mapping || {})) {
                if (key !== 'root' && value.message?.inserted_at) {
                    timestamps.push(value.message.inserted_at);
                }
            }
        }
    } else if (platform === 'grok') {
        for (const convo of conversations) {
            for (const resp of convo.responses || []) {
                const createTime = resp.response?.create_time;
                if (createTime?.$date?.$numberLong) {
                    timestamps.push(createTime.$date.$numberLong);
                }
            }
        }
    } else if (platform === 'mistral') {
        for (const convo of conversations) {
            if (convo.createdAt) timestamps.push(convo.createdAt);
        }
    }
    
    return timestamps;
}



export const PageUpload = ({ next,
    prev,
    moveToEnd,
    payingParticipants,
    donationOptions,
    sessionId,
    platform,
    emailIdentifier,
    amountTobePayed,
    setAmountToBePayed,
    userData,
    setUserData,
    setDemographicSurveyQuestions,
    setTechsavvinessSurveyQuestions,
    setUsageSurveyQuestions }) => {

    const [fileCheck, setFileCheck] = useState(false);
    const [fileName, setFileName] = useState(null);
    const [submissionStage, setSubmissionStage] = useState("RequestFile");
    const [fileReceived, setFileReceived] = useState(null);

    // GPT related states
    const [GPTConversations,setGPTConversations] = useState(null);
    const [GPTSharedConversations,setGPTSharedConversations] = useState(null);
    const [GPTMessageFeedbacks,setGPTMessageFeedbacks] = useState(null);
    const [GPTUploadedImages, setGPTUploadedImages] = useState(null);
    const [GPTUploadedImagesObj, setGPTUploadedImagesObj] = useState(null);

    // Gemini related states
    const [GeminiConversations, setGeminiConversations] = useState(null);
    const [GoogleSearches, setGoogleSearches] = useState(null);
    const [AIModeActivity, setAIModeActivity] = useState(null);
    const [GeminiFiles, setGeminiFiles] = useState(null);        // list of file paths
    const [GeminiFilesZipObj, setGeminiFilesZipObj] = useState(null); // filtered zip as File

    // Claude related states
    const [ClaudeConversations, setClaudeConversations] = useState(null);
    const [ClaudeProjects, setClaudeProjects] = useState(null);

    // DeepSeek related states
    const [DeepSeekConversations, setDeepSeekConversations] = useState(null);

    // Mistral related states
    const [MistralConversations, setMistralConversations] = useState(null);
    const [MistralFilesBlob, setMistralFilesBlob] = useState(null); 

    // Grok related states
    const [GrokConversations, setGrokConversations] = useState(null);
    const [GrokProjects, setGrokProjects] = useState(null);
    const [GrokTasks, setGrokTasks] = useState(null);
    const [GrokMediaPosts, setGrokMediaPosts] = useState(null);


    /*-----------------------*/ 
    const confirmText = 'Are you sure you want to submit your data? If you click "Yes", your donated data will be transferred to our database.'

    const openNotificationFileAccepted = () => {
        notification["success"]({
            message: <Text strong>{'File Combatible'}</Text>,
            description:
                "The selected file has the expected format. If for any reason you wish to remove the selected file, press the bin icon next to the file's name.",
        });
    };

    const openNotificationFileRejectedPlatform = (platformName, errorList) => {
        notification["error"]({
            message: <Text strong>{'File Incompatible'}</Text>,
            className: "Text",
            description:
                <div>
                    <Text>{`The selected file does not have the expected format. Please ensure that you select an unmodified file downloaded directly from ${platformName}.\n\n`}</Text>
                    <Text strong>{"The following error was found:\n- " + errorList.join("\n- ")}</Text>
                </div>,
        });
    }

    const openAlreadySubmittedNotification = () => {
        notification["error"]({
            message: <Text strong>{"Donation already submitted"}</Text>,
            description: (
            <Text className="Text">
                We already have a donation recorded for this email and platform. You don’t need to submit again.
            </Text>
            ),
            duration: 8,
        });
    };

    const openNotificationInvalidSubmission = () => {
        notification.error({
            message: "Submission incomplete",
            description: (
            <div>
                <p>
                We could not detect the required conversation data in your file.
                </p>
                <p>
                This usually happens if:
                </p>
                <ul>
                <li>The wrong file was uploaded</li>
                <li>The file structure is incomplete</li>
                <li>The upload was interrupted</li>
                </ul>
                <p>
                Please re-upload your and try again.
                </p>
            </div>
            ),
            duration: 10,
        });
    }
    const openNotificationNotEnoughActivity = () => {
        notification.error({
            message: "Minimum activity requirement not met",
            description: (
            <div>
                <p>
                We could not verify that your account has the minimum required activity (at least 90 days of activity) to be eligible for this study.
                </p>
            </div>
            ),
            duration: 10,
        });
    }


    // function to handle file before upload for ChatGPT
    const beforeUploadChatGPT = (file) => {
        setFileCheck(true);
        var extension = file.name.split('.').pop();
        if (extension === 'zip') {
            var zip = new JSZip();
            try {
                zip.loadAsync(file).then(async function(content) {
                    var errors = [];
                    if (donationOptions.ChatGPTConversations){
                        var conversations_path = 'conversations.json';
                        if (zip.file(conversations_path) != null ) {
                            const error = await content.files[conversations_path].async('text').then(function(fileText) {
                            var conversations = JSON.parse(fileText);

                            var conversation_len = conversations.length;
                            var faced_error = 0;
                            if (Array.isArray(conversations)  && conversation_len >=10) { // make sure to change this back to what was desired originally : 100 
                                //console.log("Setting conversations");
                                //console.log(conversation_len, typeof(conversations));
                                setGPTConversations(conversations);
                                //console.log(conversations[0]);
                            }
                            else {  
                                faced_error = 1;      
                            }
                            return faced_error;                             
                        });
                            if (error === 1) {
                                errors.push("Minimum requirement not met: Not enough conversations found.");
                            }
                        }
                        else {
                            errors.push('Conversations not detected!');
                        }
                    }

                    if (donationOptions.ChatGPTMessagefeedback){
                        var message_path = 'message_feedback.json';
                        if (zip.file(message_path) != null ) {
                            const error = await content.files[message_path].async('text').then(function(fileText) {
                            var message_feedbacks = JSON.parse(fileText);
                            var faced_error = 0;
                            if (Array.isArray(message_feedbacks)) {
                                setGPTMessageFeedbacks(message_feedbacks);
                            }
                            else {  
                                faced_error = 1;      
                            }
                            return faced_error;                             
                        });
                            if (error === 1) {
                                errors.push("Not enough message feedbacks are found.");
                            }
                        }
                        else {
                            errors.push('Message feedbacks not detected!');
                        }
                    }

                    if (donationOptions.ChatGPTsharedConversations){
                        var shared_path = 'shared_conversations.json';
                        if (zip.file(shared_path) != null ) {
                            const error = await content.files[shared_path].async('text').then(function(fileText) {
                            var shared_conversations = JSON.parse(fileText);
                            var faced_error = 0;
                            if (Array.isArray(shared_conversations)) {
                                setGPTSharedConversations(shared_conversations);
                            }
                            else {  
                                faced_error = 1;      
                            }
                            return faced_error;                             
                        });
                            if (error === 1) {
                                errors.push("Not enough shared conversations are found.");
                            }
                        }
                        else {
                            errors.push('Shared Conversations not detected!');
                        }
                    }

                    if (donationOptions.ChatGPTUploadedImages) {
                
                        let uploadedImagePaths = [];

                        zip.forEach((relativePath, file) => {
                            if (!file.dir && relativePath.split('/').pop().startsWith('file')) {
                                uploadedImagePaths.push(relativePath);
                            }
                        });

                        if (uploadedImagePaths.length === 0) {
                            errors.push("No uploaded or generated files detected.");
                        } else {
                            //console.log(uploadedImagePaths);
                            setGPTUploadedImages(uploadedImagePaths);
                            
                            const uploadedZip = new JSZip();
                            const promises = [];

                            zip.forEach((relativePath, file) => {
                                if (!file.dir && relativePath.split('/').pop().startsWith('file')) {
                                    const p = file.async('blob').then(blob => {
                                        const filename = relativePath.split('/').pop();
                                        uploadedZip.file(filename, blob);
                                    });
                                    promises.push(p);
                                }
                            });

                            await Promise.all(promises);
                            const zippedBlob = await uploadedZip.generateAsync({ type: "blob" });
                            const finalZipFile = new File([zippedBlob], "filtered_images.zip", { type: "application/zip" });
                            setGPTUploadedImagesObj(finalZipFile);
                        }
                    }

                    return errors;

                }).then(function(x) {
                    if (x.length === 0) {
                        setFileName(file.name);
                        setFileReceived(true);
                        openNotificationFileAccepted();                    
                    } else {
                        openNotificationFileRejectedPlatform("ChatGPT", x);
                    }
                });
            }
            catch {
                openNotificationFileRejectedPlatform("ChatGPT", ['File not supported!'])
            }
            setFileCheck(false);
        }
        return false;
    };

    const beforeGeminiUpload = (file) => {
        setFileCheck(true);

        const extension = file.name.split(".").pop()?.toLowerCase();
        if (extension !== "zip") {
            openNotificationFileRejectedPlatform("Gemini", [
            "File not supported! Please upload a .zip file.",
            ]);
            setFileCheck(false);
            return false;
        }

        const zip = new JSZip();

        // normalize paths 
        const norm = (p) => (p || "").replace(/\\/g, "/");
        const lower = (p) => norm(p).toLowerCase();

        // Find the *Gemini Apps* MyActivity.json anywhere in the zip
        const findGeminiMyActivity = () => {
            const matches = [];

            zip.forEach((relativePath, f) => {
            if (f.dir) return;

            const p = norm(relativePath);
            const lp = p.toLowerCase();

            // "…/Gemini Apps/MyActivity.json" anywhere in the zip
            if ((lp.endsWith("/myactivity.json") || lp.endsWith("/my activity.json")) && lp.includes("/gemini apps/")) {
                matches.push(p);
            }
            });

            if (matches.length === 0) return null;
            // prefer the closest match we find 
            matches.sort((a, b) => a.length - b.length);
            return zip.file(matches[0]);
        };

        const getDirPrefix = (path) => {
            const p = norm(path);
            const idx = p.lastIndexOf("/");
            return idx >= 0 ? p.slice(0, idx + 1) : "";
        };

        zip
            .loadAsync(file)
            .then(async (content) => {
            const errors = [];
            let appsFile = null;
            if (!appsFile) appsFile = findGeminiMyActivity();

            if (!appsFile) {
                errors.push(
                'Gemini Conversations file not found! Please ensure your export includes a "Gemini Apps/MyActivity.json" or "Gemini Apps/My Activity.json" file.'
                );
            } else {
                // Derive the actual Gemini Apps folder prefix from the matched file
                const appsPath = norm(appsFile.name); // JSZipFile has .name
                const geminiAppsDirPrefix = getDirPrefix(appsPath);

                try {
                const text = await appsFile.async("text");
                const json = JSON.parse(text);

                console.log("GeminiConversations parsed:", json.length);
                if (json.length < 40) { 
                    errors.push(`Not enough Gemini messages found (${json.length}).`);
                } else {
                    setGeminiConversations(json);
                }
                } catch (e) {
                    console.error("Error parsing Gemini Apps MyActivity.json", e);
                    errors.push("Gemini Apps MyActivity.json could not be parsed.");
                }

                // Optional Gemini attachments 
                if (donationOptions?.GeminiUploadedFiles === true) {
                const geminiFilePaths = [];

                zip.forEach((relativePath, f) => {
                    if (f.dir) return;

                    const rp = norm(relativePath);
                    const lrp = rp.toLowerCase();

                    if (!rp.startsWith(geminiAppsDirPrefix)) return;
                    if (lrp.endsWith("/myactivity.json") || lrp.endsWith("/my activity.json")) return;

                    const isAttachment =
                    lrp.endsWith(".png") ||
                    lrp.endsWith(".jpg") ||
                    lrp.endsWith(".jpeg") ||
                    lrp.endsWith(".webp") ||
                    lrp.endsWith(".gif") ||
                    lrp.endsWith(".pdf") ||
                    lrp.endsWith(".heic") ||
                    lrp.endsWith(".bmp") || 
                    lrp.endsWith(".csv") ||
                    lrp.endsWith(".txt"); 

                    if (isAttachment) geminiFilePaths.push(rp);
                });

                if (geminiFilePaths.length === 0) {
                    errors.push(
                    "No Gemini attachments found in the Gemini Apps folder, but you selected Gemini attachments. " +
                        "Either include attachments or uncheck that option."
                    );
                    setGeminiFiles(null);
                    setGeminiFilesZipObj(null);
                } else {
                    setGeminiFiles(geminiFilePaths);

                    const attachmentsZip = new JSZip();
                    const promises = geminiFilePaths.map((path) =>
                    content.files[path].async("blob").then((blob) => {
                        const filename = path.split("/").pop();
                        attachmentsZip.file(filename, blob);
                    })
                    );

                    await Promise.all(promises);

                    const zippedBlob = await attachmentsZip.generateAsync({ type: "blob" });
                    const finalZipFile = new File([zippedBlob], "gemini_attachments.zip", {
                    type: "application/zip",
                    });
                    setGeminiFilesZipObj(finalZipFile);
                }
                } else {
                setGeminiFiles(null);
                setGeminiFilesZipObj(null);
                }
            }

            return errors;
            })
            .then((errors) => {
                if (errors.length === 0) {
                    setFileName(file.name);
                    setFileReceived(true);
                    openNotificationFileAccepted();
                } else {
                    openNotificationFileRejectedPlatform("Gemini", errors);
                }
                setFileCheck(false);
            })
            .catch((e) => {
                //console.error("Gemini upload error:", e);
                openNotificationFileRejectedPlatform("Gemini", [
                        "Missing/invalid data files. Please check the files you are donating and try again!",
                    ]);
                setFileCheck(false);
            });

        return false;
    };

    const beforeClaudeUpload = (file) => {

        setFileCheck(true);
        // check file extension to be zip 
        var extension = file.name.split('.').pop(); 

        if (extension === 'zip') {
            var zip = new JSZip();
            try {
                zip.loadAsync(file).then(async function(content) {
                    var errors = [];
                    if (donationOptions.ClaudeConversations){
                        var conversations_path = 'conversations.json';
                        if (zip.file(conversations_path) != null ) {
                            const error = await content.files[conversations_path].async('text').then(function(fileText) {
                            var conversations = JSON.parse(fileText);

                            const sigCheck = validateConversationSignature(conversations, "claude");

                            //console.log(conversations[0]);
                            console.log("Claude conversations parsed:", conversations.length);
                            var conversation_len = conversations.length;
                            var faced_error = 0;
                            // check if conversations is an array, verifies the signature (has the correct attributes) and has at least x entries here: 
                            if (Array.isArray(conversations)  && sigCheck.ok  && conversation_len >= 10) { //Todo: make sure to change this later
                                setClaudeConversations(conversations);
                            }
                            else {  
                                faced_error = 1;      
                            }
                            return faced_error;                             
                        });
                            if (error === 1) {
                                errors.push("Your file does not meet the minimum requirements: Not enough conversations found or file integrity check failed.");
                            }
                        }
                        else {
                            errors.push('Conversations not detected!');
                        }
                        
                    }
                    if (donationOptions.ClaudeProjects){
                        
                            var projects_path = 'projects.json';
                            if (zip.file(projects_path) != null ) {
                                const error = await content.files[projects_path].async('text').then(function(fileText) {
                                var projects = JSON.parse(fileText);
                                var faced_error = 0;
                                if (Array.isArray(projects) && projects.length >=1) { 
                                    setClaudeProjects(projects);
                                }
                                else {
                                    faced_error = 1;
                                }
                                return faced_error;
                            });
                                if (error === 1) {
                                    errors.push("No projects found. Go back to options and change your selection if you wish to donate conversations only.");
                                }
                            }
                            else {
                                errors.push('Projects not detected!');
                            } 
                    }

                    return errors;

                }).then(function(x) {
                    if (x.length === 0) {
                        setFileName(file.name);
                        setFileReceived(true);
                        openNotificationFileAccepted();                    
                    } else {
                        openNotificationFileRejectedPlatform("Claude", x);
                    }
                });
            }
            catch {
                openNotificationFileRejectedPlatform("Claude", ['File not supported!'])
            }
            setFileCheck(false);
        }
        return false;
    };

    const beforeDeepSeekUpload = (file) => {
        setFileCheck(true);

        // check file extension to be zip
        var extension = file.name.split('.').pop();
        if (extension === 'zip') {
            var zip = new JSZip();
            try {
                zip.loadAsync(file).then(async function(content) {
                    var errors = [];
                    if (donationOptions.DeepSeekConversations){
                        var conversations_path = 'conversations.json';
                        if (zip.file(conversations_path) != null ) {
                            const error = await content.files[conversations_path].async('text').then(function(fileText) {
                            var conversations = JSON.parse(fileText);

                            var sigCheck = validateConversationSignature(conversations, "deepseek");

                            console.log("DeepSeek conversations parsed:", conversations.length);
                            var conversation_len = conversations.length;
                            var faced_error = 0;
                            if (Array.isArray(conversations)  && sigCheck.ok  && conversation_len >=10) { // make sure to change this later back to what is desired 
                                setDeepSeekConversations(conversations);
                            }
                            else {
                                faced_error = 1;
                            }
                            return faced_error;
                        });

                            if (error === 1) {
                                errors.push("Your file does not meet the minimum requirements: Not enough conversations found or file integrity check failed.");
                            }
                        }
                        else {
                            errors.push('Conversations not found in the donated data!');
                        }
                    }
                    return errors;
                }).then(function(x) {
                    if (x.length === 0) {
                        setFileName(file.name);
                        setFileReceived(true);
                        openNotificationFileAccepted();
                    } else {
                        openNotificationFileRejectedPlatform("DeepSeek", x);
                    }
                });
            }
            catch {
                openNotificationFileRejectedPlatform("DeepSeek", ['File not supported!'])
            }
            setFileCheck(false);
        }
        return false;
    };

    const beforeMistralUpload = async (file) => {
        setFileCheck(true);

        // For Mistral file attachments
        const mistralFilesZip = new JSZip();
        let mistralAttachedFilesCount = 0;

        const extension = file.name.split('.').pop();
        if (extension === 'zip') {

            const zip = new JSZip();
            try {
                const content = await zip.loadAsync(file);
                const errors = [];
                let allConversationsData = [];
                let totalConversationsCount = 0;

                if (donationOptions.MistralConversations) {                    
                    // collect conversation files paths
                    const jsonFilePaths = [];
                        zip.forEach((relativePath, f) => {
                            const fileName = relativePath.split('/').pop();
                            // Check: Not a directory AND starts with 'chat' AND ends with '.json'
                            if (!f.dir && fileName.startsWith('chat') && fileName.endsWith('.json')) {
                                jsonFilePaths.push(relativePath);
                            }
                    });
                    if (jsonFilePaths.length === 0) {
                        errors.push('No conversation files found in the donated data, or files failed integrity check. Try again, or contact us on Prolific.');
                    } else {
                        // process files concurrently
                        const results = await Promise.all(
                            jsonFilePaths.map(async (path) => {
                                try {
                                    const fileText = await content.files[path].async('text');
                                    const conversations = JSON.parse(fileText);
                                    if (Array.isArray(conversations)) {
                                        return { success: true, data: conversations };
                                    }
                                    return { success: false, error: `Files failed integrity check. Try again, or contact us on Prolific.` };
                                } catch (e) {
                                    return { success: false, error: `File is not valid JSON.` };
                                }
                            })
                        );

                        // aggregate all the files in one 
                        results.forEach(res => {
                            if (res.success) {
                                allConversationsData = [...allConversationsData, ...res.data];
                                totalConversationsCount += res.data.length;
                            } else {
                                errors.push(res.error);
                            }
                        });

                        // validation check --> TODO
                        if (totalConversationsCount < 10) {
                            errors.push("Not enough conversations found in the donated data.");
                        }
                    }
                }

                if (donationOptions.MistralUploadedFiles) {
                    const filePromises = [];
                    
                    // Regex to find paths inside any folder ending in "-files"
                    // Example: "chat-id03847504663-files/image.png"
                    const fileFolderRegex = /-files\//;

                    zip.forEach((relativePath, f) => {
                        if (!f.dir && fileFolderRegex.test(relativePath)) {
                            const filePromise = f.async('blob').then((blob) => {
                                const fileName = relativePath.split('/').pop();
                                mistralFilesZip.file(fileName, blob);
                                mistralAttachedFilesCount++;
                            });
                            filePromises.push(filePromise);
                        }
                    });

                    await Promise.all(filePromises);

                    if (mistralAttachedFilesCount === 0) {
                        errors.push("No attached files found, despite selecting the option to donate them. Please either include files or uncheck that option.");
                    }
                }

                if (errors.length === 0) {
                    setMistralConversations(prev => prev ? prev.concat(allConversationsData) : allConversationsData);
                    // If we collected files, generate the new ZIP blob
                    if (mistralAttachedFilesCount > 0) {
                        const mistralFinalFilesBlob = await mistralFilesZip.generateAsync({ type: "blob" });
                        setMistralFilesBlob(mistralFinalFilesBlob); 
                    }
                    setFileName(file.name);
                    setFileReceived(true);
                    openNotificationFileAccepted();
                } else {
                    openNotificationFileRejectedPlatform("Mistral", errors);
                }

            } catch (err) {
                console.error(err);
                openNotificationFileRejectedPlatform("Mistral", ['Failed to process zip archive.']);
            }
            setFileCheck(false);
        }

        return false;
    };

    const beforeGrokUpload = async (file) => {
        setFileCheck(true);

        const extension = file.name.split(".").pop()?.toLowerCase();
        if (extension !== "zip") {
            openNotificationFileRejectedPlatform("Grok", ["File not supported! Please upload a .zip file."]);
            setFileCheck(false);
            return false;
        }

        const zip = new JSZip();

        try {
            const content = await zip.loadAsync(file);
            const errors = [];

            const targetFilename = "prod-grok-backend.json"; // expected file name
            let conversationsPath = null;

            if (donationOptions?.GrokConversations) {
                // Find the file anywhere in the zip
                Object.keys(content.files).forEach((relativePath) => {
                    const f = content.files[relativePath];
                    if (!f.dir && relativePath.toLowerCase().endsWith(targetFilename.toLowerCase())) {
                        conversationsPath = relativePath;
                    }
                });

                if (!conversationsPath) {
                    errors.push(`Conversations file (${targetFilename}) not found in the donated data!`);
                } else {
                    try {
                        const fileText = await content.files[conversationsPath].async("text");
                        const parsed = JSON.parse(fileText);

                        // Grok exports are usually: { conversations: [...] }
                        const conversationsArray =
                            Array.isArray(parsed) ? parsed :
                            Array.isArray(parsed?.conversations) ? parsed.conversations :
                            null;

                        const projectsArray = 
                            Array.isArray(parsed) ? null :
                            Array.isArray(parsed?.projects) ? parsed.projects :
                            null; 
                        
                        const tasksArray =
                            Array.isArray(parsed) ? null :
                            Array.isArray(parsed?.tasks) ? parsed.tasks :
                            null;
                        const mediaPostsArray =
                            Array.isArray(parsed) ? null :
                            Array.isArray(parsed?.media_posts) ? parsed.media_posts :   
                            null;

                        if (!Array.isArray(conversationsArray)) {
                            errors.push(
                            `Unexpected Grok file format.`
                            );
                        } else if (conversationsArray.length < 10) {  
                            errors.push(
                            `Minimum requirement not met: only ${conversationsArray.length} conversations found.`
                            );
                        } else {
                            setGrokConversations(conversationsArray);
                        }

                        if (donationOptions?.GrokProjects === true) {   
                            if (!Array.isArray(projectsArray)) {
                                errors.push("Could not find any projects data even though you selected the option to donate them. Please check your file and try again, or uncheck that option.");
                            } else if (projectsArray.length === 0) {
                                errors.push("You do not have any projects to donate. Please uncheck this option.");
                            } else {
                                    setGrokProjects(projectsArray);
                                }
                        }
                        if (donationOptions?.GrokTasks === true) {  
                            if (!Array.isArray(tasksArray)) {
                                errors.push("Could not find any tasks data even though you selected the option to donate them. Please check your file and try again, or uncheck that option.");
                            } else if (tasksArray.length === 0) {   
                                errors.push("You do not have any tasks to donate. Please uncheck this option.");
                            } else {
                                setGrokTasks(tasksArray);
                            }
                        }
                        if (donationOptions?.GrokMediaPosts === true) {
                            if (!Array.isArray(mediaPostsArray)) {
                                errors.push("Could not find any media posts data even though you selected the option to donate them. Please check your file and try again, or uncheck that option.");
                            } else if (mediaPostsArray.length === 0) {
                                errors.push("You do not have any media posts to donate. Please uncheck this option.");
                            } else {
                                setGrokMediaPosts(mediaPostsArray);
                            }
                        }
                    } catch (e) {
                        console.error(e);
                        errors.push("Failed to parse the Grok conversation file.");
                    }
                }
            }


            if (errors.length === 0) {
                setFileName(file.name);
                setFileReceived(true);
                openNotificationFileAccepted();
            } else {
                openNotificationFileRejectedPlatform("Grok", errors);

                // allow reupload
                setFileName(null);
                setFileReceived(false);
                setGrokConversations(null);
                setGrokProjects(null);
                setGrokMediaPosts(null);
                setGrokTasks(null);
            }
        } catch (err) {
            console.error(err);
            openNotificationFileRejectedPlatform("Grok", ["File not supported or corrupted!"]);

            // allow reupload
            setFileName(null);
            setFileReceived(false);
            setGrokConversations(null);
            setGrokMediaPosts(null);
            setGrokProjects(null);
            setGrokTasks(null);
        } finally {
            setFileCheck(false);
        }

        return false;
};


    var beforeUploadFunction = null;
        switch (platform) {
        case "chatgpt":
            beforeUploadFunction = beforeUploadChatGPT;
            break;
        case "gemini":
            beforeUploadFunction = beforeGeminiUpload;
            break;
        case "claude":
            beforeUploadFunction = beforeClaudeUpload;
            break;
        case "deepseek":
            beforeUploadFunction = beforeDeepSeekUpload;
            break;
        case "mistral":
            beforeUploadFunction = beforeMistralUpload;
            break;
        case "grok":
            beforeUploadFunction = beforeGrokUpload;
            break;
        default:
            beforeUploadFunction = () => false;
            break;
    }    

    const removeFile = () => {
        setFileReceived(false);
        setFileName(null);
    };

    const onClickSubmit = () => {
        FetchFromBackend(
            `donations/exists/${encodeURIComponent(md5(emailIdentifier))}/platform/${encodeURIComponent(platform)}`,
            () => {}, 
            () => {
                ErrorConnectionFailed();
            },
            async (res) => {
                if (res?.exists === true) {
                    //console.log(res); 
                    openAlreadySubmittedNotification();
                    setSubmissionStage("RequestFile");
                }
                else{
                    // If not exists, proceed with normal submission
                    await submitDonation();
                }
            }
        );
    };

    const submitDonation = async () => {
        setSubmissionStage("Transfer");
        // ---------------------- ChatGPT submission flow ----------------------
        if (platform === "chatgpt") {
            // debugging 
            //console.log("State before submission:");
            //console.log("GPTConversations:", GPTConversations);
            //console.log("GPTSharedConversations:", GPTSharedConversations);
            //console.log("GPTMessageFeedbacks:", GPTMessageFeedbacks);
            //console.log("GPTUploadedImages:", GPTUploadedImages);

            const platformDonationOptions = filterDonationOptionsForPlatform(donationOptions, platform);

            const depData = anonymize_chatgpt_data(
                GPTConversations,
                GPTSharedConversations,
                GPTMessageFeedbacks,
                GPTUploadedImages
            );

            var submission = JSON.stringify({
                "session_id": sessionId.session_id,
                "platform": platform,
                "donated_data": depData,
                "donated_options": platformDonationOptions,
                "source": "unknown",
                "email_md5": md5(emailIdentifier)
            });

            // 1. Send donation data
            SendToBackend(
                submission,
                'donations/upsert/',
                () => {
                    // 2. On donation success, calculate payment and send payment data
                    var payment_amount = calculate_payment_amount_chatgpt(
                        donationOptions.ChatGPTsharedConversations,
                        donationOptions.ChatGPTMessagefeedback,
                        donationOptions.ChatGPTUploadedImages,
                        true,
                    );

                    //console.log("Payment amount to be added = " + payment_amount);

                    setAmountToBePayed(payment_amount);

                    var payment_submission = JSON.stringify({
                        "email": emailIdentifier,
                        "email_md5": md5(emailIdentifier),
                        "platform": platform,
                        "bonus_payment": payment_amount,
                        "donation_options": platformDonationOptions,
                        "survey_completed": true
                    });

                    SendToBackend(
                        payment_submission,
                        'payments/upsert/',
                        () => {
                            // 3. On payment success, upload files to the servers 
                            UploadFiles(md5(emailIdentifier),
                                GPTUploadedImagesObj,
                                () => {
                                    // All done successfully
                                    setSubmissionStage("Done");
                                    moveToEnd();

                                    // Clear all data
                                    setGPTConversations(null);
                                    setGPTMessageFeedbacks(null);
                                    setGPTSharedConversations(null);
                                    setGPTUploadedImages(null);
                                    setGPTUploadedImagesObj(null);
                                },
                                () => {
                                    setSubmissionStage("RequestFile");
                                    ErrorConnectionFailed();
                                }
                            );
                        },
                        () => {
                            // Payment failed
                            setSubmissionStage("RequestFile");
                            ErrorConnectionFailed();
                        }
                    );
                },
                () => {
                    // Donation submission failed
                    setSubmissionStage("RequestFile");
                    removeFile();
                    ErrorConnectionFailed();
                }
            );
            

        }
        // ---------------------- Gemini submission flow ----------------------
        if (platform === "gemini") {
            // debugging 
            //console.log("State before submission:");
            //console.log("GeminiConversations:", GeminiConversations);
            //console.log("GoogleSearches:", GoogleSearches);
            //console.log("AIModeActivity:", AIModeActivity);

            const depData = anonymize_gemini_data(
                GeminiConversations, 
                GoogleSearches,
                AIModeActivity,
                GeminiFiles
            );

            // check submission data 
            if (!validateDepData(depData, platform)) {
                openNotificationInvalidSubmission();
                setSubmissionStage("RequestFile");
                return false; 
            }

            const verification_payload = {
                'platform' : platform, 
                'timestamps': extractTimestamps(GeminiConversations, platform) 
            }; 

            try {
                const ok = await verify90DaysofActivity(verification_payload, platform);
                console.log("90 days of activity check:", ok);
                if (!ok) {
                    openNotificationNotEnoughActivity();
                    setSubmissionStage("RequestFile");
                    removeFile();
                    return false;
                }
            } catch (e) {
                setSubmissionStage("RequestFile");
                return;
            }


            
            // filter the donation options 
            const platformDonationOptions = filterDonationOptionsForPlatform(donationOptions, platform);
            

            var submission = JSON.stringify({
                "session_id": sessionId.session_id,
                "platform": platform,
                "donated_data": depData,
                "donated_options": platformDonationOptions,
                "source": "unknown",
                "email_md5": md5(emailIdentifier)
            });

            // 1. Send donation data
            SendToBackend(
                submission,
                'donations/upsert/',
                () => {
                    // check whether the data in conversations in not null 
                    
                    // 2. On donation success, calculate payment and send payment data
                    var payment_amount = calculate_payment_amount_gemini(
                        donationOptions.GoogleSearches,
                        donationOptions.AIModeActivity,
                        donationOptions.GeminiUploadedFiles,
                        true,
                    );

                    //console.log("Payment amount to be added = " + payment_amount);

                    setAmountToBePayed(payment_amount);

                    var payment_submission = JSON.stringify({
                        "email": emailIdentifier,
                        "email_md5": md5(emailIdentifier),
                        "platform": platform,
                        "bonus_payment": payment_amount,
                        "donation_options": platformDonationOptions,
                        "survey_completed": true
                    });

                    SendToBackend(
                        payment_submission,
                        'payments/upsert/',
                        () => {
                            // On payment success: upload the files to the servers 
                            UploadFiles(md5(emailIdentifier),
                                GeminiFilesZipObj,
                                () => {
                                    // All done successfully
                                    //console.log("Gemini donation and payment submission successful.");
                                    setSubmissionStage("Done");
                                    moveToEnd();

                                    setGeminiConversations(null);
                                    setGoogleSearches(null);
                                    setAIModeActivity(null);
                                    setGeminiFiles(null);
                                    setGeminiFilesZipObj(null);
                                },
                                () => {
                                    // File upload failed
                                    //console.log("Gemini file upload failed.");
                                    setSubmissionStage("RequestFile");
                                    ErrorConnectionFailed();
                                }
                            );
                        },
                        () => {
                            // Payment failed
                            setSubmissionStage("RequestFile");
                            ErrorConnectionFailed();
                        }
                    );
                },
                () => {
                    // Donation submission failed
                    setSubmissionStage("RequestFile");
                    removeFile();
                    ErrorConnectionFailed();
                }
            );
            

        }
        if (platform === "claude") {
        
            const depData = anonymize_claude_data(
                ClaudeConversations, 
                ClaudeProjects
            );

            // check submission data 
            if (!validateDepData(depData, platform)) {
                openNotificationInvalidSubmission();
                setSubmissionStage("RequestFile");
                return; 
            }

            const verification_payload = {
                'platform' : platform, 
                'timestamps': extractTimestamps(ClaudeConversations, platform) 
            }; 

            try {
                const ok = await verify90DaysofActivity(verification_payload, platform);
                console.log("90 days of activity check:", ok);
                if (!ok) {
                    openNotificationNotEnoughActivity();
                    setSubmissionStage("RequestFile");
                    removeFile();
                    return false;
                }
            } catch (e) {
                setSubmissionStage("RequestFile");
                return;
            }

            // filter donation options 
            const platformDonationOptions = filterDonationOptionsForPlatform(donationOptions, platform);
            
            var submission = JSON.stringify({
                "session_id": sessionId.session_id,
                "platform": platform,
                "donated_data": depData,
                "donated_options": platformDonationOptions,
                "source": "unknown",
                "email_md5": md5(emailIdentifier)
            });

            // 1. Send donation data
            SendToBackend(
                submission,
                'donations/upsert/',
                () => {
                    // 2. On donation success, calculate payment and send payment data
                    var payment_amount = calculate_payment_amount_claude(
                        donationOptions.ClaudeProjects,
                        false,
                    );

                    setAmountToBePayed(payment_amount);

                    var payment_submission = JSON.stringify({
                        "email": emailIdentifier,
                        "email_md5": md5(emailIdentifier),
                        "platform": platform,
                        "bonus_payment": payment_amount,
                        "donation_options": platformDonationOptions,
                        "survey_completed": true
                    });

                    SendToBackend(
                        payment_submission,
                        'payments/upsert/',
                        () => {
                            // On payment success
                            //console.log("Claude donation and payment submission successful.");
                            setSubmissionStage("Done");
                            moveToEnd();

                            setClaudeConversations(null);
                        },
                        () => {
                            // Payment failed
                            setSubmissionStage("RequestFile");
                            ErrorConnectionFailed();
                        }
                    );
                },
                () => {
                    // Donation submission failed
                    setSubmissionStage("RequestFile");
                    removeFile();
                    ErrorConnectionFailed();
                }
            );
        }
        if (platform === "deepseek") {
            // debugging 
            //console.log("State before submission:");
            //console.log("DeepSeekConversations:", DeepSeekConversations);

            const depData = anonymize_deepseek_data(
                DeepSeekConversations
            );

            // check submission data 
            if (!validateDepData(depData, platform)) {
                openNotificationInvalidSubmission();
                setSubmissionStage("RequestFile");
                return; 
            }

            const verification_payload = {
                'platform' : platform, 
                'timestamps': extractTimestamps(DeepSeekConversations, platform) 
            }; 

            try {
                const ok = await verify90DaysofActivity(verification_payload, platform);
                console.log("90 days of activity check:", ok);
                if (!ok) {
                    openNotificationNotEnoughActivity();
                    setSubmissionStage("RequestFile");
                    removeFile();
                    return false;
                }
            } catch (e) {
                setSubmissionStage("RequestFile");
                return;
            }

            // filter donation options 
            const platformDonationOptions = filterDonationOptionsForPlatform(donationOptions, platform);
            
            var submission = JSON.stringify({
                "session_id": sessionId.session_id,
                "platform": platform,
                "donated_data": depData,
                "donated_options": platformDonationOptions,
                "source": "unknown",
                "email_md5": md5(emailIdentifier)
            });

            // 1. Send donation data
            SendToBackend(
                submission,
                'donations/upsert/',
                () => {
                    // 2. On donation success, calculate payment and send payment data
                    var payment_amount = calculate_payment_amount_deepseek();

                    //console.log("Payment amount to be added = " + payment_amount);

                    setAmountToBePayed(payment_amount);

                    var payment_submission = JSON.stringify({
                        "email": emailIdentifier,
                        "email_md5": md5(emailIdentifier),
                        "platform": platform,
                        "bonus_payment": payment_amount,
                        "donation_options": platformDonationOptions,
                        "survey_completed": true
                    });

                    SendToBackend(
                        payment_submission,
                        'payments/upsert/',
                        () => {
                            // On payment success
                            //console.log("DeepSeek donation and payment submission successful.");
                            setSubmissionStage("Done");
                            moveToEnd();

                            setDeepSeekConversations(null);
                        },
                        () => {
                            // Payment failed
                            setSubmissionStage("RequestFile");
                            ErrorConnectionFailed();
                        }
                    );
                },
                () => {
                    // Donation submission failed
                    setSubmissionStage("RequestFile");
                    removeFile();
                    ErrorConnectionFailed();
                }
            );
        }
        if (platform === "mistral") {
            // debugging 
            //console.log("State before submission:");
            //console.log("MistralConversations:", MistralConversations);

            const depData = anonymize_mistral_data(
                MistralConversations, 
                MistralFilesBlob
            );

            // check submission data 
            if (!validateDepData(depData, platform)) {
                openNotificationInvalidSubmission();
                setSubmissionStage("RequestFile");
                return; 
            }

            const verification_payload = {
                'platform' : platform, 
                'timestamps': extractTimestamps(MistralConversations, platform) 
            }; 

            try {
                const ok = await verify90DaysofActivity(verification_payload, platform);
                console.log("90 days of activity check:", ok);
                if (!ok) {
                    openNotificationNotEnoughActivity();
                    setSubmissionStage("RequestFile");
                    removeFile();
                    return false;
                }
            } catch (e) {
                setSubmissionStage("RequestFile");
                return;
            }

            // filter donation options 
            const platformDonationOptions = filterDonationOptionsForPlatform(donationOptions, platform);
            
            var submission = JSON.stringify({
                "session_id": sessionId.session_id,
                "platform": platform,
                "donated_data": depData,
                "donated_options": platformDonationOptions,
                "source": "unknown",
                "email_md5": md5(emailIdentifier)
            });
            // 1. Send donation data
            SendToBackend(
                submission,
                'donations/upsert/',
                () => {
                    // 2. On donation success, calculate payment and send payment data
                    var payment_amount = calculate_payment_amount_mistral(
                        donationOptions.MistralUploadedFiles,
                        false,
                    );

                    //console.log("Payment amount to be added = " + payment_amount);

                    setAmountToBePayed(payment_amount);

                    var payment_submission = JSON.stringify({
                        "email": emailIdentifier,
                        "email_md5": md5(emailIdentifier),
                        "platform": platform,
                        "bonus_payment": payment_amount,
                        "donation_options": platformDonationOptions,
                        "survey_completed": true
                    });

                    SendToBackend(
                        payment_submission,
                        'payments/upsert/',
                        () => {
                            // On payment success upload the files to the servers
                            UploadFiles(md5(emailIdentifier),
                                MistralFilesBlob,
                                () => {
                                    // All done successfully
                                    console.log("Mistral donation, payment and file upload successful.");
                                    setSubmissionStage("Done");
                                    moveToEnd();

                                    // Clear all data
                                    setMistralConversations(null);
                                    setMistralFilesBlob(null);
                                },
                                () => {
                                    // File upload failed
                                    console.log("Mistral file upload failed.");
                                    setSubmissionStage("RequestFile");
                                    ErrorConnectionFailed();
                                }
                            );
                        },
                        () => {
                            // Payment failed
                            setSubmissionStage("RequestFile");
                            ErrorConnectionFailed();
                        }
                    );
                },
                () => {
                    // Donation submission failed
                    setSubmissionStage("RequestFile");
                    removeFile();
                    ErrorConnectionFailed();
                }
            );
        }
        if (platform === "grok") {
            // debugging 
            //console.log("State before submission:");
            //console.log("GrokConversations:", GrokConversations);

            const depData = anonymize_grok_data(
                GrokConversations, 
                GrokProjects, 
                GrokTasks, 
                GrokMediaPosts
            );

            // check submission data 
            if (!validateDepData(depData, platform)) {
                openNotificationInvalidSubmission();
                setSubmissionStage("RequestFile");
                return; 
            }

            const verification_payload = {
                'platform' : platform, 
                'timestamps': extractTimestamps(GrokConversations, platform) 
            }; 

            try {
                const ok = await verify90DaysofActivity(verification_payload, platform);
                console.log("90 days of activity check:", ok);
                if (!ok) {
                    openNotificationNotEnoughActivity();
                    setSubmissionStage("RequestFile");
                    removeFile();
                    return false;
                }
            } catch (e) {
                setSubmissionStage("RequestFile");
                return;
            }

            // filter donation options 
            const platformDonationOptions = filterDonationOptionsForPlatform(donationOptions, platform);
            
            var submission = JSON.stringify({
                "session_id": sessionId.session_id,
                "platform": platform,
                "donated_data": depData,
                "donated_options": platformDonationOptions,
                "source": "unknown",
                "email_md5": md5(emailIdentifier)
            });

            // 1. Send donation data
            SendToBackend(
                submission,
                'donations/upsert/',
                () => {
                    // 2. On donation success, calculate payment and send payment data
                    var payment_amount = calculate_payment_amount_grok(
                        donationOptions.GrokProjects,
                        donationOptions.GrokTasks,
                        donationOptions.GrokMediaPosts,
                        true, // for survey 
                    );

                    //console.log("Payment amount to be added = " + payment_amount);

                    setAmountToBePayed(payment_amount);

                    var payment_submission = JSON.stringify({
                        "email": emailIdentifier,
                        "email_md5": md5(emailIdentifier),
                        "platform": platform,
                        "bonus_payment": payment_amount,
                        "donation_options": platformDonationOptions,
                        "survey_completed": true
                    });

                    SendToBackend(
                        payment_submission,
                        'payments/upsert/',
                        () => {
                            // On payment success
                            console.log("Grok donation and payment submission successful.");
                            setSubmissionStage("Done");
                            moveToEnd();
                            setGrokConversations(null);
                        },
                        () => {
                            // Payment failed
                            setSubmissionStage("RequestFile");
                            ErrorConnectionFailed();
                        }
                    );
                },
                () => {
                    // Donation submission failed
                    setSubmissionStage("RequestFile");
                    removeFile();
                    ErrorConnectionFailed();
                }
            );  
        }
    };

    const FileUpload = () => {
        return (
            <Dragger
                name='file'
                accept={(platform === "tiktok") ? '.json,.zip' : '.zip'}
                beforeUpload={beforeUploadFunction}
                showUploadList={false}
                disabled={fileCheck || fileReceived}
                multiple={false}>
                <Spin spinning={fileCheck} tip="Your anonymised file is being checked and depersonalised." />
                <p className="ant-upload-drag-icon">
                    <InboxOutlined style={{ color: (fileCheck || fileReceived) ? 'gray' : '#5497CC' }} />
                </p>
                <p className="ant-upload-text">
                    Click or drag file to this area to begin the processing of your data {(platform === 'tiktok') ? '(.json or .zip file)' : '(.zip file)'}
                </p>
                <p className="ant-upload-hint">
                    
                </p>
            </Dragger>
        );
    }

    const FileTracker = () => {
        return (
            <div hidden={false}>
                <Text className="UploadText"> {fileName}</Text>
                <Tooltip placement="right" title="Delete uploaded file">
                    <Button className="UploadText" type="text" icon={<DeleteOutlined />} onClick={removeFile} hidden={!fileReceived} />
                </Tooltip>
            </div>
        );
    }

    const SubmitButton = () => {
        return (
            <div>
                <Popconfirm title={confirmText} onConfirm={onClickSubmit} okText="Yes" cancelText="No">
                    <Button
                        className="TopMargin"
                        type="primary"
                        shape="round"
                        icon={<UploadOutlined />}
                        size="large"
                        disabled={!fileReceived}>
                        Submit
                    </Button>
                </Popconfirm>
            </div>
        );
    }

    const OptionCard = () => {
        return (
            <Card className="OptionCard">
                <div><Text className="OptionCard" strong={true}>Note:</Text> Our website automatically removes all personal identifiers as mentioned earlier and changes the input file so that we only collect the parts of the data you opted-in. We also provide the same functionality in an offline depersonalizer using a Python script. More information on how you can depersonalize your data using our Python script can be found <a href="https://github.com/zsavvas/TikTok-utils " target="_blank">here</a> (this is optional and this is in case you want to edit automatically and review the file before using our website). Our website performs the same operations as the Python script on the browser and on the client-side (<strong>we do not transfer the raw personalized data to our server!</strong>).</div>
            </Card>
        );
    }

    const Spinner = () => {
        return (
            <div hidden={!(submissionStage === "Transfer")} className="TopMargin">
                <Spin size="large" tip="Your file is being transferred to our database." />
            </div>
        );
    }

    const NavigationButtons = () => {
        return (
            <div style={{ marginTop: "1em" }} hidden={submissionStage === "Done"}>
                <Button
                    className="RightMargin"
                    onClick={prev}>
                    Previous
                </Button>
                <Button
                    type="primary"
                    onClick={next}
                    disabled>
                    Next
                </Button>
            </div>
        );
    };

    return (
        <div>
            <div hidden={submissionStage !== "RequestFile"}>
                <FileUpload />
                <FileTracker />
                <SubmitButton />
                {platform === "tiktok" && <OptionCard />}
            </div>
            <Spinner />
            <div hidden={submissionStage !== "Done"}>
                <PageDone 
                    payingParticipants={payingParticipants} 
                    emailIdentifier={emailIdentifier} 
                    amountToBePayed={amountTobePayed} />
            </div>
            <NavigationButtons />
        </div>
    );
}

export default PageUpload;